import { answerSubCategorySchema } from "@/schema/console/evaluation-reports/AnswerSubCategory";
import { z } from "zod";

export const answerCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  answer_sub_categories: z.array(answerSubCategorySchema),
});

export type AnswerCategory = z.infer<typeof answerCategorySchema>;
